import { api } from "api/apiService";

/**
 * Завантажує список виключень з урахуванням параметрів фільтрації.
 * @param {object} [filters={}] - Об'єкт з параметрами для фільтрації (напр., пошуку).
 * @returns {Promise<Array>} Проміс, що повертає масив з об'єктами виключень.
 */
export const fetchExclusions = (filters = {}) => {
  // Копіюємо лише ті фільтри, які мають реальне значення
  const cleanFilters = {};
  for (const key in filters) {
    const value = filters[key];
    if (value !== null && value !== undefined && value !== "") {
      cleanFilters[key] = value;
    }
  }
  return api.get("/exclusions", cleanFilters);
};

/**
 * Завантажує список виключень з урахуванням параметрів фільтрації.
 * @param {object} [filters={}] - Об'єкт з параметрами для фільтрації (напр., пошуку).
 * @returns {Promise<Array>} Проміс, що повертає масив з об'єктами виключень.
 */
export const upsertExclusion = (article, newPrice) => {
  const url = `/exclusions/${encodeURIComponent(article)}`;
  const body = { new_price: parseFloat(newPrice) };
  return api.put(url, body);
};

/**
 * Видаляє виключення за артикулом.
 * @param {string} article - Артикул товару, виключення для якого потрібно видалити.
 * @returns {Promise<object>} Проміс, що повертає відповідь від сервера.
 */
export const deleteExclusion = (article) => {
  const url = `/exclusions/${encodeURIComponent(article)}`;
  return api.delete(url);
};
